import { AlreadySubscribedError } from '../utils/error'

const getConfig = (method: 'GET' | 'POST') => ({
  method,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${process.env.REACT_APP_AIRTABLE_ACCESS_TOKEN}`,
  },
})

const baseUrl = `https://api.airtable.com/v0/${process.env.REACT_APP_AIRTABLE_BASE_ID}/t_email`

const isSubscribed = async (email: string) => {
  const url = `${baseUrl}?filterByFormula=email='${encodeURIComponent(email)}'`
  const response = await fetch(url, getConfig('GET'))
  const data = await response.json()
  return data.records.length > 0
}

const subscribe = async (email: string) => {
  const isAlreadySubscribed = await isSubscribed(email)
  if (isAlreadySubscribed) {
    throw new AlreadySubscribedError('Email is already subscribed')
  }
  const url = `${baseUrl}`
  const body = JSON.stringify({ records: [{ fields: { email } }] })
  const response = await fetch(url, { ...getConfig('POST'), body })
  const data = await response.json()
  return data as { id: string }[]
}

export const subService = {
  isSubscribed,
  subscribe,
}
